import { Slot } from "@radix-ui/react-slot";
import type { ComponentPropsWithRef } from "react";
import type { AsChild } from "@/types";
import { cn } from "@/utils/style.ts";

export type FloaterProps = ComponentPropsWithRef<"div"> & AsChild;
export function Panel({ className, asChild = false, ...props }: FloaterProps) {
    const Component = asChild ? Slot : "div";

    return <Component {...props} className={cn("panel", className)} />;
}

type FloaterItemProps = ComponentPropsWithRef<"div"> & AsChild;
export function PanelItem({ className, asChild = false, ...props }: FloaterItemProps) {
    const Component = asChild ? Slot : "div";

    return <Component {...props} className={cn("panel__item", className)} />;
}
